import HttpFactory from '~/repository/factory';

class EmailTemplateModule extends HttpFactory {
  private RESOURCE = '/email-templates';

  async list() {
    return this.get(this.RESOURCE);
  }

  async getById(id: string) {
    return this.get(`${this.RESOURCE}/${id}`);
  }

  async update(
    id: string,
    data: {
      name?: string;
      description?: string;
      subject?: string;
      body_html: string;
      body_plaintext?: string;
      variables?: Array<{
        name: string;
        description: string;
        required: boolean;
      }>;
    },
  ) {
    return this.put(`${this.RESOURCE}/${id}`, data);
  }

  async preview(data: {
    body_html: string;
    engine: 'handlebars' | 'gotmpl';
    context: Record<string, unknown>;
  }) {
    return this.post(`${this.RESOURCE}/preview`, data);
  }
}

export default EmailTemplateModule;
